import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { withTranslation } from 'react-i18next'
import { Form, Input, Button } from 'antd'
import { createItem } from '../../atoms/formItems/AItem'
import  { required, passwordsMatch } from '../../enums/formValidations'
import { resetChangePasswordForm } from '../../actions/authActions'

const FormItem = Form.Item

const AInput = createItem(Input)

class ChangePasswordForm extends React.Component {
	componentDidMount = () => {
		const { resetChangePasswordForm } = this.props
		resetChangePasswordForm()
	}

	render = () => {
		const { handleSubmit, pristine, submitting } = this.props
		const { t } = this.props
		
		return (
			<Form onSubmit={handleSubmit} className="form-border">
				<div style={{textAlign: 'center'}}>
					<h2 style={{color: 'white'}}>{t('components:passwordChange')}</h2>
				</div>

				<Field name="password" placeholder={t('components:passwordPlaceholder')} component={AInput} 
					type='password' required={true} validate={[required]} wrapperCol={{span: 24}} />
				
				<Field name="confirmPassword" placeholder={t('components:confirmPasswordPlaceholder')} component={AInput} 
					type='password' required={true} validate={[required, passwordsMatch]} wrapperCol={{span: 24}} />

				<FormItem wrapperCol={{span: 24}}>
					<Button type="primary" disabled={pristine || submitting} htmlType="submit" style={{ marginRight: "10px" }}>
						{t('components:changePassword')}
					</Button>
				</FormItem>
			</Form>
		)
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		resetChangePasswordForm: () => {
			dispatch(resetChangePasswordForm())
		}
	}
}

export default compose(
	connect(null, mapDispatchToProps),
	withTranslation('components')
)(ChangePasswordForm)
